var map = {
	"./button.svg": "7bad",
	"./checkbox.svg": "934b",
	"./draggable.svg": "5fb2",
	"./field.svg": "2631",
	"./headline.svg": "8304",
	"./image.svg": "bbec",
	"./rank.svg": "4e87",
	"./social.svg": "6210",
	"./spacer.svg": "363b",
	"./survey.svg": "6614",
	"./survey_old.svg": "5dcc",
	"./text.svg": "ecc3",
	"./voucher-white.svg": "921b",
	"./voucher.svg": "aa49",
	"./wheel_spin-white.svg": "b7b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09b1";